export default "__VITE_ASSET__BlWE8idB__"